/**
 * Staff Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const staffAPI = {
  getAll: (params) => apiClient.get('/staff', { params }),
  getById: (id) => apiClient.get(`/staff/${id}`),
  getSummary: (params) => apiClient.get('/staff/stats/summary', { params }),
  create: (data) => apiClient.post('/staff', data),
  update: (id, data) => apiClient.put(`/staff/${id}`, data),
  delete: (id) => apiClient.delete(`/staff/${id}`),
};

export default staffAPI;

